import { request } from '@/data/request';

export type SystemDocumentKey = 'terms_of_use' | 'privacy_policy';

export interface SystemDocument {
  ID: number;
  key: SystemDocumentKey;
  title: string;
  version: string;
  file_name: string;
  is_active: boolean;
}

export interface SystemDocumentsCurrentResponse {
  documents: SystemDocument[];
  requires_acceptance: boolean;
}

export interface SystemDocumentsAcceptanceResponse {
  documents: SystemDocument[];
  accepted: boolean;
}

export const fetchCurrentSystemDocuments =
  async (): Promise<SystemDocumentsCurrentResponse> => {
    return request<SystemDocumentsCurrentResponse>({
      method: 'get',
      url: '/system-documents/current',
    });
  };

export const acceptSystemDocuments =
  async (): Promise<SystemDocumentsAcceptanceResponse> => {
    return request<SystemDocumentsAcceptanceResponse>({
      method: 'post',
      url: '/system-documents/acceptance',
    });
  };
